export default "__VITE_ASSET__826e3ea1__"